/**
 * @file   src\components\MemberWantAd\SegmentDivider.js
 * @brief  This file is responsible for segment divider component.
 * @date   June, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
const SegmentDivider = () => {
  return <div className="segment-divider mb-0">OR</div>;
};
export default SegmentDivider;
